<span [appDateWithOffset]="dateFormats.AM_PM">
  {{ text }}
</span>
